// レシート一覧の絞り込みチップ
//
// 通知ログ画面のドメインチップと同じ操作感。何も選んでいなければ全件を出し、
// 複数選んだときはどれかに当てはまるものを出す。
import type { ReceiptListSummary } from '@/api/types/receipt'
import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'

import { RECEIPT_FILTERS, type ReceiptFilterFlag } from '../receipt-filters'

type Props = {
  /** 件数はチップ以外の条件で数えたもの（選ぶたびに他が 0 になると比べられないため） */
  summary: ReceiptListSummary | undefined
  selected: ReadonlySet<ReceiptFilterFlag>
  onToggle: (value: ReceiptFilterFlag) => void
}

export const ReceiptFilterChips = ({ summary, selected, onToggle }: Props) => {
  return (
    <div className="flex shrink-0 gap-1.5 overflow-x-auto px-4 pb-2">
      {RECEIPT_FILTERS.map((filter) => {
        const count = summary?.[filter.countKey] ?? 0
        const isActive = selected.has(filter.value)
        return (
          <button
            key={filter.value}
            type="button"
            aria-pressed={isActive}
            onClick={() => onToggle(filter.value)}
            className="shrink-0"
          >
            <Badge
              variant="outline"
              className={cn(
                'cursor-pointer text-xs',
                filter.color,
                selected.size > 0 && (isActive ? 'ring-1 ring-current' : 'opacity-30'),
              )}
            >
              {filter.label} {count}
            </Badge>
          </button>
        )
      })}
    </div>
  )
}
